import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Checkbox, Form, Input, InputNumber } from "antd"
import TwoRowsHeaderCell from "../../../../../common/cells/TwoRowsHeaderCell"
import {
    formItemLayout8to16,
    formItemLayoutBalanced,
    renderInputOnOffCheckboxFormItem,
} from "../../../_components/SettingFormItems"
import type { SettingFormItem } from "../../../types"
import * as Color from "../../../../../../constants/colors"
import { WrappedFormUtils } from "antd/lib/form/Form"

type Props = {
    form: WrappedFormUtils
    settings: SettingFormItem
    acceptOnlyFutureOrderForDelivery: boolean
    isDeliveryFutureOrders: boolean
    leadTimeActiveDelivery: boolean
    futureDeliveryDays: Maybe<number>
    onStateValueChanged: (key: string, val: Maybe<any>) => void
    onChangeCallback: () => void
}

export const FUTURE_ORDERING_DAYS_DEFAULT = 0

export const DeliveryFutureOrders = (props: Props) => {
    return (
        <div>
            {renderInputOnOffCheckboxFormItem(
                props.settings,
                "MIB_IS_FUTURE_ORDER_DELIVERY_VALUE",
                "isDeliveryFutureOrders",
                "Accept Delivery Orders for Future",
                "",
                props.settings.isDeliveryFutureOrders && props.settings.isDeliveryFutureOrders.indeterminate === true
                    ? undefined
                    : props.isDeliveryFutureOrders,
                val => props.onStateValueChanged("isDeliveryFutureOrders", val),
                null,
                "receipt-setting-form-item",
                null
            )}
            {props.isDeliveryFutureOrders && (
                <>
                    {renderInputOnOffCheckboxFormItem(
                        props.settings,
                        "MIB_ACCEPT_ONLY_FUTURE_ORDER_FOR_DELIVERY",
                        "acceptOnlyFutureOrderForDelivery",
                        "Only Accept Future Orders",
                        "Require your customers to set a time/date to be able to place an order",
                        props.settings.acceptOnlyFutureOrderForDelivery &&
                            props.settings.acceptOnlyFutureOrderForDelivery.indeterminate === true
                            ? undefined
                            : props.acceptOnlyFutureOrderForDelivery,
                        val => props.onStateValueChanged("acceptOnlyFutureOrderForDelivery", val),
                        {
                            marginLeft: "4rem",
                        },
                        "receipt-setting-form-item",
                        {
                            marginLeft: "3rem",
                        }
                    )}

                    {renderLeadTimeSettings(
                        props,
                        "MIB_FUTURE_ORDER_LEAD_TIME_ACTIVE_DELIVERY",
                        "MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_DELIVERY"
                    )}

                    <Form.Item
                        style={{
                            marginBottom: "0.5rem",
                            marginLeft: "4rem",
                            paddingTop: "1rem",
                        }}
                        className="receipt-setting-form-item"
                        label={
                            <TwoRowsHeaderCell
                                value="Set a Maximum Number of Days for Future Ordering"
                                subValue={
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "-1rem ",
                                        }}>
                                        0 = Only for later today, 1 = Up to tomorrow, etc.
                                    </span>
                                }
                            />
                        }
                        {...formItemLayoutBalanced}>
                        <InputNumber
                            key="price-input"
                            style={{
                                textAlign: "right",
                                width: "12rem",
                            }}
                            placeholder="7"
                            onBlur={e => {
                                // @ts-expect-error
                                const newMaxFutureDays = Math.round(e.target.value || FUTURE_ORDERING_DAYS_DEFAULT)
                                props.onStateValueChanged("futureDeliveryDays", newMaxFutureDays)
                                const leadTimeSettingMinutes =
                                    props.form.getFieldValue("MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_DELIVERY") ||
                                    props.settings.MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_DELIVERY.value
                                const leadTimeDeliveryMinutesValue = Number(leadTimeSettingMinutes)
                                const leadTimeDays = leadTimeDeliveryMinutesValue / 60 / 24
                                const maxLeadTimeDays = newMaxFutureDays + 1
                                props.form.setFields({
                                    MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_DELIVERY: {
                                        value: leadTimeSettingMinutes,
                                        errors:
                                            props.leadTimeActiveDelivery && leadTimeDays >= maxLeadTimeDays
                                                ? [new Error("")]
                                                : undefined,
                                    },
                                })
                            }}
                            min={0}
                            max={30}
                            step={1}
                            // @ts-expect-error
                            value={props.futureDeliveryDays}
                            onChange={val => props.onStateValueChanged("futureDeliveryDays", val)}
                            onFocus={e => e.target.select()}
                        />
                    </Form.Item>
                </>
            )}
        </div>
    )
}

const renderLeadTimeSettings = (
    props: Props,
    activeKey: string,
    minutesKey: string // "MIB_FUTURE_ORDER_LEAD_TIME_MINUTES_DELIVERY",
) => {
    const leadTimeSettingMinutes =
        props.form.getFieldValue(minutesKey) != null
            ? props.form.getFieldValue(minutesKey)
            : props.settings[minutesKey]?.value
    const leadTimeHoursTotal = Math.floor(Number(leadTimeSettingMinutes) / 60)
    const leadTimeDaysInputValue = Math.floor(leadTimeHoursTotal / 24)
    const leadTimeHoursInputValue = leadTimeHoursTotal - leadTimeDaysInputValue * 24
    const leadTimeDisabled = !props.leadTimeActiveDelivery
    const settings = Object.assign({}, props.settings)
    const inputSuffixStyle = {
        pointerEvents: "none",
        fontSize: "13px",
        opacity: 0.75,
        paddingRight: "4px",
    }
    const errorMessage =
        !leadTimeDisabled && props.form.getFieldError(minutesKey) ? (
            <span>
                Lead Time must be less than <b>Maximum Number of Days for Future Ordering</b>
            </span>
        ) : null
    const showDescMessage = !errorMessage && !leadTimeDisabled && (leadTimeHoursInputValue || leadTimeDaysInputValue)
    return (
        <Form.Item
            style={{
                marginBottom: "0rem",
                marginLeft: "4rem",
                paddingTop: "18px",
                paddingBottom: "2px",
            }}
            className="receipt-setting-form-item"
            label={
                <TwoRowsHeaderCell
                    value="Require Lead Time"
                    subValue={
                        <span
                            style={{
                                position: "absolute",
                                top: "-1rem ",
                            }}>
                            Set lead time to give you ample time for preparation
                        </span>
                    }
                />
            }
            {...formItemLayout8to16}>
            {props.form.getFieldDecorator(minutesKey)(<span />)}
            <div
                style={{
                    position: "relative",
                    top: "-2px",
                }}>
                <div
                    style={{
                        float: "right",
                        marginLeft: "1rem",
                    }}>
                    <Checkbox
                        onChange={e => {
                            props.onStateValueChanged("leadTimeActiveDelivery", e.target.checked)

                            if (!e.target.checked) {
                                const leadTimeMinutes =
                                    props.form.getFieldValue(minutesKey) || props.settings[minutesKey].value
                                props.form.setFields({
                                    [minutesKey]: {
                                        value: leadTimeMinutes,
                                        errors: undefined,
                                    },
                                })
                            } else {
                                const maxFutureDays = props.futureDeliveryDays
                                const leadTimeMinutes =
                                    props.form.getFieldValue(minutesKey) || props.settings[minutesKey].value
                                const leadTimeMinutesValue = Number(leadTimeMinutes)
                                const leadTimeDays = leadTimeMinutesValue / 60 / 24
                                // @ts-expect-error
                                const maxLeadTimeDays = maxFutureDays + 1
                                props.form.setFields({
                                    [minutesKey]: {
                                        value: leadTimeMinutes,
                                        errors: leadTimeDays >= maxLeadTimeDays ? [new Error("")] : undefined,
                                    },
                                })
                            }

                            if (settings[activeKey]) {
                                settings[activeKey].indeterminate = false
                            }
                        }}
                        indeterminate={settings[activeKey]?.indeterminate}
                        checked={settings[activeKey]?.indeterminate === true ? undefined : props.leadTimeActiveDelivery}
                    />
                </div>
                <div
                    style={{
                        float: "right",
                        marginLeft: "0.5rem",
                    }}>
                    <Input
                        className="lead-time-input lead-time-hours-input"
                        style={{
                            width: "4.75rem",
                            marginRight: 0,
                            opacity: leadTimeDisabled ? 0.5 : 1,
                            pointerEvents: leadTimeDisabled ? "none" : "all",
                        }}
                        min={0}
                        max={24}
                        type="tel"
                        pattern="[0-9]*"
                        onFocus={e => e.target.select()}
                        value={leadTimeHoursInputValue}
                        suffix={
                            // @ts-expect-error
                            <span className="ant-input-suffix" style={inputSuffixStyle}>
                                Hours
                            </span>
                        }
                        onChange={e => {
                            const value = Number(e.target.value) || 0
                            const newLeadTimeMinutes = value * 60 + leadTimeDaysInputValue * 24 * 60
                            const leadTimeDays = newLeadTimeMinutes / 60 / 24
                            // @ts-expect-error
                            const maxDays = props.futureDeliveryDays + 1
                            props.form.setFields({
                                [minutesKey]: {
                                    value: newLeadTimeMinutes,
                                    errors: !leadTimeDisabled && leadTimeDays >= maxDays ? [new Error("")] : undefined,
                                },
                            })
                            props.onChangeCallback()
                        }}
                        placeholder={props.settings[minutesKey]?.indeterminate ? "Multiple values" : "minutes"}
                    />
                </div>
                <div
                    style={{
                        float: "right",
                    }}>
                    <Input
                        className="lead-time-input lead-time-days-input"
                        style={{
                            width: "4.75rem",
                            marginRight: 0,
                            opacity: leadTimeDisabled ? 0.5 : 1,
                            pointerEvents: leadTimeDisabled ? "none" : "all",
                        }}
                        min={0}
                        max={365}
                        type="tel"
                        pattern="[0-9]*"
                        onFocus={e => e.target.select()}
                        value={leadTimeDaysInputValue}
                        suffix={
                            // @ts-expect-error
                            <span className="ant-input-suffix" style={inputSuffixStyle}>
                                Days
                            </span>
                        }
                        onChange={e => {
                            const value = Number(e.target.value) || 0
                            const newValue = leadTimeHoursInputValue * 60 + value * 24 * 60
                            const leadTimeDays = newValue / 60 / 24
                            // @ts-expect-error
                            const maxDays = props.futureDeliveryDays + 1
                            props.form.setFields({
                                [minutesKey]: {
                                    value: newValue,
                                    errors: !leadTimeDisabled && leadTimeDays >= maxDays ? [new Error("")] : undefined,
                                },
                            })
                            props.onChangeCallback()
                        }}
                        placeholder={
                            props.settings[minutesKey] && props.settings[minutesKey].indeterminate
                                ? "Multiple values"
                                : "minutes"
                        }
                    />
                </div>
                <div
                    style={{
                        color: Color.Grey6,
                        clear: "both",
                        fontSize: "13px",
                        visibility: showDescMessage ? "visible" : "hidden",
                        height: showDescMessage ? "auto" : "16px",
                    }}>
                    You require your customers to order ahead by{" "}
                    <b>{`${leadTimeDaysInputValue ? leadTimeDaysInputValue + " days" : ""}${
                        leadTimeDaysInputValue && leadTimeHoursInputValue ? " and " : ""
                    }${leadTimeHoursInputValue ? leadTimeHoursInputValue + " hours" : ""}.`}</b>
                </div>
                {errorMessage && (
                    <div
                        style={{
                            color: Color.Red,
                            clear: "both",
                            fontSize: "13px",
                            position: "relative",
                            top: "-14px",
                            height: "16px",
                        }}>
                        {errorMessage}
                    </div>
                )}
            </div>
        </Form.Item>
    )
}
